module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"analysis":"Analysis"},"ja":{"analysis":"解析"}}')
  delete Component.options._Ctor
}
